//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { api_RedPacketBalanceLog } from "../../../api";
import { conversion } from "../../../tool";

export default {
  name: "redPacketHistory",
  data() {
    return {
      walletData: {
        data: { list: [] },
        current: 1,
        size: 15,
      },
    };
  },
  methods: {
    // 翻页接口
    getuserBalance(obj) {
      api_RedPacketBalanceLog(obj).then((res) => {
        if (res.data.code === 0) {
          this.walletData.data.list = res.data.data.items || [];
          this.walletData.data.total = res.data.data.totalCount || 0;
        }
      });
    },
    // 翻页
    pageF(v) {
      this.getuserBalance({
        current: v,
        size: this.walletData.size,
      });
    },
  },
  filters: {
    conversion,
    add(v) {
      return v > 0 ? `+${v}` : v;
    },
  },
  created() {
    this.getuserBalance({
      current: this.walletData.current,
      size: this.walletData.size
    });
  },
};
